import { getEndpoint, getEnvironment } from '@ubi/js-utils/environment'
import { getPropertyIfPossible } from '@ubi/js-utils/utils'
import { logger } from '@/plugins/logger'

type InjectedData = {
    gatewayBaseUrl: string | null
    baseUrls: {
        KeycloakService: string
        ConfigurationService: string
    }
}

const getInjection = (key: string) => {
    const windowKey = `__${key}__`
    const placeholder = `__${key}_PLACEHOLDER__`

    const value = getPropertyIfPossible(window, windowKey)

    if (typeof value !== 'string' || value === placeholder) {
        logger.error(
            new Error(
                `Missing ${key} injection (received ${JSON.stringify(value)})`
            )
        )
        return null
    }

    return value
}

/**
 * Those informations are injected at deploy time
 */
const getInjections = (): InjectedData => {
    const defaults = {
        gatewayBaseUrl: null,
        baseUrls: {
            KeycloakService: getEndpoint('KeycloakService'),
            ConfigurationService: getEndpoint('ConfigurationService'),
        },
    }

    if (getEnvironment() === 'LOCAL') return defaults

    return {
        gatewayBaseUrl:
            getInjection('GATEWAY_BASE_URL') ?? defaults.gatewayBaseUrl,
        baseUrls: {
            KeycloakService:
                getInjection('KEYCLOAK_BASE_URL') ??
                defaults.baseUrls.KeycloakService,
            ConfigurationService:
                getInjection('CONFIGURATION_SERVICE_BASE_URL') ??
                defaults.baseUrls.ConfigurationService,
        },
    }
}

export const INJECTIONS = getInjections()
